/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidpriceiderror3Inputs */

const en_invalidpriceiderror3 = /** @type {(inputs: Invalidpriceiderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid plan selected. Please try again.`)
};

const de_invalidpriceiderror3 = /** @type {(inputs: Invalidpriceiderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiger Plan ausgewählt. Bitte versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "Invalid plan selected. Please try again." |
*
* @param {Invalidpriceiderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidpriceiderror3 = /** @type {((inputs?: Invalidpriceiderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidpriceiderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidpriceiderror3(inputs)
	return de_invalidpriceiderror3(inputs)
});
export { invalidpriceiderror3 as "invalidPriceIdError" }